export type validationRule<T, D = any> = (value: T, data?: D) => string | null;

export type schema<T> = {
    [K in keyof T]?: validationRule<T[K], T>[];
};

export type errors<T> = {
    [K in keyof T]?: string;
};

export const validate = <T extends object>(
    data: T,
    schema: schema<T>,
): errors<T> => {
    const errors: errors<T> = {};

    for (const key in schema) {
        const rules = schema[key as keyof T];
        const value = data[key as keyof T];

        if (rules) {
            for (const rule of rules) {
                const errorMessage = rule(value, data);
                if (errorMessage) {
                    errors[key as keyof T] = errorMessage;
                    break;
                }
            }
        }
    }
    return errors;
};

export const rules = {
    required:
        (message = "Este campo es requerido.") =>
            (value: any) =>
                value === null || value === undefined || String(value).trim() === ""
                    ? message
                    : null,

    minLength:
        (min: number, message?: string) => (value: string | undefined | null) =>
            value && value.length < min
                ? message || `Debe tener al menos ${min} caracteres.`
                : null,
    minItems:
        (min: number, message?: string) => (value: any[] | undefined | null) =>
            !value || value.length < min
                ? message || `Debe seleccionar al menos ${min} elemento(s).`
                : null,

    isEmail:
        (message = "Formato de correo electrónico inválido.") =>
            (value: string | undefined | null) =>
                value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? message : null,

    isStrongPassword: () => (value: string | undefined | null) => {
        if (!value) return null;
        const strongRegex = new RegExp("^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,})");
        if (!strongRegex.test(value)) {
            return "Debe tener al menos 8 caracteres, incluyendo letras y números.";
        }
        return null;
    },
};
